import { AfterViewInit, Component, EventEmitter, Input, Output } from "@angular/core";
import { ErrorClass, UnauthorizedError, ValidationError, VerificationCode, InternalServerError } from "@models";
import { Helper } from "@helpers/functions";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { NEW_VERIFICATION_PIN_LENGTH, VERIFICATION_PIN_LENGTH } from "@helpers/constants";
import { FiatTransaction } from "@models/transaction";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";

@Component({
	selector: "two-fa-verify",
	templateUrl: "./verification-pin.component.html",
	standalone: false
})
export class VerificationPinComponent implements AfterViewInit, BpModalHasSave {
	@Input()
	public offer: FiatTransaction;
	@Input()
	public pinSent: boolean = true;
	@Output()
	public pinSentF: EventEmitter<boolean> = new EventEmitter();

	public pinLength: number = VERIFICATION_PIN_LENGTH;

	@Output()
	// TODO: eslint fix
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	public accept = new EventEmitter<any>();

	@Input()
	public voiceCallEnabled: boolean = true;

	@Input()
	public descriptionKey: string = "enter_sms_code_sent_to_verified_phone";

	public inputBpType: string = "sms";
	public inputSecurity: boolean = false;
	public lastLength: number = 0;

	public verificationPin: VerificationCode = new VerificationCode();

	public constructor(
		protected apicallService: ApicallService,
		protected translationService: TranslationService,
		protected infoService: InfoService
	) {}

	public ngAfterViewInit(): void {
		if (!this.pinSent) {
			this.createPinRequest("sms");
		}
	}

	public sixDigitsDone(): boolean {
		return this.verificationPin.getCode().length === NEW_VERIFICATION_PIN_LENGTH;
	}

	public get done(): boolean {
		return this.verificationPin.getCode().length === VERIFICATION_PIN_LENGTH;
	}

	public autoAccept(): void {
		if (this.verificationPin._code.length !== this.lastLength) {
			this.lastLength = this.verificationPin._code.length;
			if (this.verificationPin._code.length === this.pinLength) {
				this.save();
			}
		}
	}

	public createPinRequest(type: string): void {
		const url =
			"fiatwallet/" + this.offer.getFiatWalletId() + "/deposit/" + this.offer.getId() + "/approve/" + type;
		this.apiCallRequestPin(url);
	}

	// API call Request GET:

	protected apiCallRequestPin(url: string): void {
		this.apicallService.get(url).subscribe(
			() => {
				this.pinSentF.emit(true);
				this.offer.setTriedPin(true);
				this.infoService.setSuccess(this.translationService.translate("sms_code_was_sent"));
			},
			(err) => Helper.handleError(err)
		);
	}

	public save(): void {
		if (!this.done) {
			return;
		}

		const a = new ApicallOption(FiatTransaction, this.verificationPin);
		a.ignore401 = true;
		const url = "fiatwallet/" + this.offer.getFiatWalletId() + "/deposit/" + this.offer.getId() + "/confirm";

		this.apiCallSendPin(url, a);
	}

	protected apiCallSendErrorHandling(error: Error): void {
		if (error instanceof ErrorClass) {
			if (error instanceof UnauthorizedError) {
				this.infoService.setError(this.translationService.translate("info_text_verify_pin_invalid_pin"));
			} else if (error instanceof ValidationError) {
				this.infoService.setError(error);
				this.verificationPin.setValidationErrors(error);
			} else if (error instanceof InternalServerError) {
				this.infoService.setError(error);

				this.accept.emit(null);
			} else {
				this.infoService.setError(error);
			}
		} else {
			console.error("Err: ", error);
		}
	}

	// API call Confirm POST:

	protected apiCallSendPin(url: string, option: ApicallOption): void {
		this.apicallService.post(url, option).subscribe(
			(ans) => {
				this.offer = ans[0];
				this.accept.emit(this.offer);
			},
			(err) => {
				this.apiCallSendErrorHandling(err);
			}
		);
	}
}
